import { queryString } from 'common/utils';

export type OtpVerifyQueryParams = { otpAccessToken: string };
export type ErrorPageQueryParams = {
  status?: number | null;
  message?: string | null;
};

class Paths {
  reports = '/reports';
  sessions = '/sessions';
  settings = '/settings';

  createSessionKey = 'create';
  createSession = `${this.sessions}/${this.createSessionKey}`;

  sessionKey = ':sessionId';
  getSessionDetails = (id: string): string => `${this.sessions}/${id}`;
  sessionEditKey = 'edit';
  getEditSession = (id: string): string =>
    `${this.getSessionDetails(id)}/${this.sessionEditKey}`;

  auth = '/auth';

  loginKey = 'login';
  login = `${this.auth}/${this.loginKey}`;

  otpVerifyKey = 'verify-otp';
  getOtpVerify = (params: OtpVerifyQueryParams): string =>
    queryString.stringifyUrl({
      url: `${this.auth}/${this.otpVerifyKey}`,
      query: params,
    });

  error = '/error';
  getError = (params: ErrorPageQueryParams): string =>
    `${this.error}?${queryString.stringify(params)}`;
}

const PATHS = new Paths();

export default PATHS;
